import { Component, Input } from '@angular/core';
import { LucideAngularModule } from 'lucide-angular';
import { NgClass } from '@angular/common';

@Component({
  selector: 'app-button',
  imports: [LucideAngularModule, NgClass],
  templateUrl: './button.component.html',
  styleUrl: './button.component.css',
  standalone: true,
})
export class ButtonComponent {
  @Input() label!: string;
  @Input() icon?: any;
  @Input() style = 'primary';
  @Input() size = 'normal';
  @Input() disabled = false;
  @Input() leftRound = true;
  @Input() rightRound = true;

  getClasses() {
    const classes = [];

    // Common classes
    classes.push(
      'inline-flex',
      'items-center',
      'gap-2',
      'text-sm',
      'font-medium',
      'transition-all',
      'duration-200',
      'ease-in-out',
      'shadow-theme-xs',
    );

    if (this.leftRound && this.rightRound) {
      classes.push('rounded-lg');
    } else {
      if (this.leftRound) {
        classes.push('rounded-l-lg');
      }
      if (this.rightRound) {
        classes.push('rounded-r-lg');
      }
    }

    // Style-specific classes
    if (this.style === 'primary') {
      if (this.disabled) {
        classes.push('bg-brand-300', 'text-white', 'cursor-not-allowed');
      } else {
        classes.push('bg-brand-500', 'text-white', 'hover:bg-brand-600', 'active:bg-brand-700', 'active:shadow-none');
      }
    }

    if (this.style === 'secondary') {
      if (this.disabled) {
        classes.push(
          'bg-gray-100',
          'text-gray-400',
          'ring-1',
          'ring-inset',
          'ring-gray-200',
          'dark:bg-gray-700',
          'dark:text-gray-500',
          'dark:ring-gray-600',
          'cursor-not-allowed',
        );
      } else {
        classes.push(
          'bg-white',
          'text-gray-700',
          'ring-1',
          'ring-inset',
          'ring-gray-300',
          'hover:bg-gray-50',
          'active:bg-gray-200',
          'dark:bg-gray-800',
          'dark:text-gray-400',
          'dark:ring-gray-700',
          'dark:hover:bg-white/[0.03]',
          'dark:active:bg-gray-700',
        );
      }
    }

    // Size-specific classes
    if (this.size === 'normal') {
      classes.push('px-4', 'py-3');
    }
    if (this.size === 'big') {
      classes.push('px-5', 'py-3.5');
    }

    return classes;
  }
}
